import { PriceObjectDto } from "@modules/common/priceObject/gateway/priceObjectApiDto"
import { PaymentError } from "@modules/finances/types/stripeErrorTypes"
import { User } from "@modules/profile/profileTypes"
import { ItemProgramInfinite, ProgramInfinite, ProgramInfiniteTypeOf } from "@modules/programs/programInfiniteTypes"
import {
  ItemProgramOnOff,
  ProgramOnOff,
  ProgramOnOffStatus,
  ProgramOnOffTypeOf,
} from "@modules/programs/programOnOffTypes"
import { PromoCode } from "@modules/promoCode/types/promoCodeTypes"
import { HUImage } from "@modules/types/imageTypes"

export type ProgramTypeOf = typeof ProgramOnOffTypeOf | typeof ProgramInfiniteTypeOf

export const ProgramContentTypeOf = "PROGRAM"

export type ItemProgram = ItemProgramInfinite | ItemProgramOnOff

export type Program = ProgramInfinite | ProgramOnOff

export enum ProgramVisibility {
  PRIVATE = "PRIVATE",
  PUBLIC = "PUBLIC",
}

export enum ProgramType {
  VIRTUAL = "VIRTUAL",
  ONOFF = "ON_OFF",
  IN_BOX = "IN_BOX",
}

export type ProgramPrice = {
  value: number
  currency: string
}

export enum ProgramSubscriptionStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  PAUSE = "PAUSE",
  PAYMENT_IN_ERROR = "PAYMENT_IN_ERROR",
  PENDING_CANCELLATION = "PENDING_CANCELLATION",
  PENDING_PAYMENT = "PENDING_PAYMENT",
  PENDING_REQUEST = "PENDING_REQUEST",
  TRIALING = "TRIALING",
  TRIAL_PENDING_CANCELLATION = "TRIAL_PENDING_CANCELLATION",
  ACTIVE_BUNDLE = "ACTIVE_BUNDLE", // Program of a bundle - followed
  INACTIVE_BUNDLE = "INACTIVE_BUNDLE", // Program of a bundle - unfollowed
}

export const allProgramFilter = ["OWNED", "SUBSCRIBED", "SHARED_COACH", "ALL"] as const
export type ProgramFilter = (typeof allProgramFilter)[number]

export type ProgramPayment = {
  amount: ProgramPrice
  promoCode?: PromoCode
  error?: PaymentError
}

export type LightProgramInfo = {
  id: string
  name: string
  image: HUImage | null
  price: PriceObjectDto | null
  _programType: ProgramTypeOf
}

export type LightProgram = {
  id: string
  name: string
  descripition: string
  image: HUImage
  owner: User
  visibility: ProgramVisibility
  scoreboardVisibility: boolean
  type: ProgramType
}

export type UserProgramItem = {
  id: string
  title: string
  description: string
  image: HUImage | null
  owner: User
  visibility: ProgramVisibility
  subscribed: boolean
  subscriptionCount: number
  price: PriceObjectDto | null
  defaultHideSessionContent: boolean
  status: ProgramOnOffStatus
  duration: number | null
  _programType: ProgramTypeOf
  sharedCoachStatus: SharedCoachStatus | null
  followedInBundle: boolean
}

export enum SharedCoachStatus {
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
  REFUSED = "REFUSED",
}

export type SharedCoach = {
  role: string // TODO refactor with SharedCoachRole
  status: SharedCoachStatus
  user: User
}

export enum SharedCoachRequestAction {
  ACCEPT = "ACCEPT",
  REFUSE = "REFUSE",
  QUIT = "QUIT",
  REMOVE = "REMOVE",
}

export const convertToLightProgramInfo = (item: ItemProgram): LightProgramInfo => {
  return {
    id: item.id,
    name: item.title,
    image: item.image,
    price: item.price,
    _programType: item._programType,
  }
}
